export default {
  historyChanges: 25,
};
